/**
 * 如果后端地址有多个，可以在这里单独配置
 */

let baseUrl1 = 'http://172.16.100.233:9559';  //地址1  

let baseUrl2 = 'http://poetry.apiopen.top';  //地址2  测试的接口地址(真实项目中可删除)


export default {
  baseUrl1,
  baseUrl2
}